<template>
    <el-dialog
            title="专业人员选择"
            :visible.sync="zhuanyeDialog"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            :show-close="false"
            width="600px"
            center>
        <el-form :model="accountForm" :rules="rules" ref="accountForm" label-width="100px">
            <el-form-item label="专业人员" prop="name">
                <el-select v-model="accountForm.id" filterable placeholder="请选择专业人员" style="width: 100%">
                    <el-option
                            v-for="item in exclusivePersonnelList"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                    </el-option>
                </el-select>
            </el-form-item>

            <el-form-item class="flex align-center justify-around" label-width="0">
                <el-button class="padding-lr-xl" @click="resetForm('accountForm')">取消</el-button>
                <el-button class="padding-lr-xl" type="primary" @click="submitForm('accountForm')">提交</el-button>
            </el-form-item>
        </el-form>
    </el-dialog>
</template>

<script>

import {updateWatchPeopleDetail2} from "@/api/service";

export default {
    name: "zhuanyeDialog",
    props: {
        zhuanyeDialog: {
            type: Boolean,
            default: false
        },
        exclusivePersonnelList: {
            type: Array,
        },
        exclusive_personnel_id:{
            type: Number ,
            default: 0
        }
    },
    data() {

        return {
            accountForm: {
                id: '',

            },
            rules: {
                id: [{required: true, message: '请选择专业人员', trigger: 'change'}],
            }
        }
    },
    computed: {
        user() {
            return this.$store.state.user
        },

    },
    created() {

    },
    methods: {

        resetForm(formName) {
            this.$refs[formName].resetFields();
            this.$emit('cancelDialog', false)
        },
        submitForm(formName) {
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    this.submitData(formName)
                }
            });
        },
        async submitData(formName) {
            let _state = await updateWatchPeopleDetail2(
                this.$route.params.id,
                this.accountForm.id,
            );
            this.$message.success(_state.info);
            this.$refs[formName].resetFields();
            this.$emit("cancelDialog", true);
        }

    },
    watch: {
        exclusive_personnel_id() {
            this.accountForm = {
                id: this.exclusive_personnel_id?this.exclusive_personnel_id:'',
            };
        },
    }
}
</script>

<style scoped lang="scss">

</style>
